export class TimeHandler {

    #toHandle: 'time-outs' | 'time-intervals'
    #tokens: Map<string, NodeJS.Timeout>

    constructor(toHandle: 'time-outs' | 'time-intervals') {
        this.#toHandle = toHandle
        this.#tokens = new Map()
    }

    set (key: string, callBack: () => void, ms: number) {
        this.clear(key)
        let id:NodeJS.Timeout = this.#toHandle === 'time-intervals' ?
            setInterval(callBack, ms) :
            setTimeout(() => {
                callBack()
                this.#tokens.delete(key)
            }, ms)
        this.#tokens.set(key, id)
    }

    clear (key: string) {
        if (this.#toHandle === 'time-outs') clearTimeout(this.#tokens.get(key))
        else clearInterval(this.#tokens.get(key))
        
        this.#tokens.delete(key)
    }

    clearAll () {
        this.#tokens.forEach((timeoutId, key) => this.clear(key))
        this.#tokens.clear()
    }

    inProcess () {
        return this.#tokens.size
    }
    
}